import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from './App.tsx';
import StateHubPage from './pages/StateHubPage.tsx';
import NotFoundPage from './pages/NotFoundPage.tsx';
import DraftsPage from './pages/DraftsPage.tsx';
import GuidePage, { GUIDE_PAGE_SLUGS } from './pages/GuidePage.tsx';
import { STATE_HUBS } from './lib/trailHubs';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/map" element={<App />} />
        <Route path="/trails" element={<App />} />
        <Route path="/stops" element={<App />} />
        <Route path="/stays" element={<App />} />
        <Route path="/plan" element={<App />} />
        <Route path="/southwest-olive-guide" element={<Navigate to={`/${STATE_HUBS[0].slug}`} replace />} />
        {STATE_HUBS.map((hub) => (
          <Route key={hub.state} path={`/${hub.slug}`} element={<StateHubPage slug={hub.slug} />} />
        ))}
        {GUIDE_PAGE_SLUGS.flatMap((slug) => [
          <Route key={`${slug}-slash`} path={`/${slug}/`} element={<GuidePage slug={slug} />} />,
          <Route key={slug} path={`/${slug}`} element={<GuidePage slug={slug} />} />,
        ])}
        <Route path="/drafts" element={<DraftsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
